export default "__VITE_ASSET__OoCb_d_S__"